// The app shell, home page, map and media list (OQ-162).
export const svShell = {
  brandAlt: 'Logotyp',
  pages: {
    somethingWentWrong: 'Något gick fel',
    notFound: '404: Sidan finns inte',
    goHome: 'Gå till startsidan'
  },
  loadingPage: {
    text: 'Laddar…'
  },
  appShell: {
    openMenu: 'Öppna menyn',
    generateCameraLink: 'Skapa kameralänk',
    settings: 'Inställningar',
    projects: 'Projekt',
    drawings: 'Ritningar',
    logout: 'Logga ut',
    somethingWentWrong: 'Något gick fel.',
    media: 'Ärenden',
    places: 'Huvudmeny',
    accountMenu: 'Kontomeny för {{name}}'
  },
  linkModal: {
    title: 'Kameralänkar',
    validFor: 'Länken nedan gäller i 12 timmar.',
    afterExpiry: 'För att nå organisationens kamera när länken har gått ut behöver du skapa en ny länk.',
    tempLink: 'Tillfällig länk:',
    permaLink: 'Permanent länk:',
    replaceWarning:
      'Den nuvarande permanenta länken och dess utskrivna QR-koder slutar fungera direkt. Vill du skapa en ny permanent länk?',
    revokeAndCreate: 'Återkalla och skapa ny',
    replaced: 'Den permanenta länken har ersatts',
    replaceFailed: 'Kunde inte ersätta den permanenta länken.',
    urlCopied: 'Länken har kopierats till urklipp',
    copyTemp: 'Kopiera tillfällig länk',
    copyPerma: 'Kopiera permanent länk',
    printTemp: 'Skriv ut QR-kod för tillfällig länk',
    printPerma: 'Skriv ut QR-kod för permanent länk',
    revokePerma: 'Återkalla permanent länk'
  },
  globalState: {
    wrongPassword: 'Fel lösenord.',
    userNotFound: 'Användaren finns inte.',
    signOutFailed: 'Kunde inte logga ut.'
  },
  homePage: {
    swapToMap: 'Byt till kartvy',
    swapToList: 'Byt till listvy',
    closeFilters: 'Stäng filter',
    filters: 'Filter',
    filtersCount: 'Filter · {{count}}',
    countAll_one: '{{count}} ärende',
    countAll_other: '{{count}} ärenden',
    countShown_one: '{{shown}} av {{count}} ärende',
    countShown_other: '{{shown}} av {{count}} ärenden'
  },
  map: {
    loadError: 'Kartan kunde inte laddas. Ladda om sidan och försök igen.',
    drawingMarker: 'Ritning: {{name}}',
    loading: 'Laddar kartan'
  },
  location: {
    noPosition: 'Ingen position',
    approximate: 'Ungefärlig position ({{accuracy}})'
  },
  sortableTable: {
    noData: 'Inget att visa',
    actions: 'Åtgärder',
    cameraLink: 'Kameralänk',
    view: 'Visa',
    restore: 'Återställ',
    changeAccountStatus: 'Ändra kontots status',
    resendActivation: 'Skicka aktiveringslänken igen'
  },
  statusDropdown: {
    none: 'Det finns inga statusar.'
  },
  mapDataList: {
    unknownOrganisation: 'Internt fel: okänd organisation.',
    somethingWentWrong: 'Något gick fel. Försök igen senare. Fel: {{error}}',
    emailSubject: 'Nedladdningslänk, TheFrozenEye',
    markReadFailed: 'Kunde inte markera ärendet som läst.',
    markUnreadFailed: 'Kunde inte markera ärendet som oläst.',
    adminComment: 'Intern kommentar',
    statusName: 'Status',
    projectName: 'Projekt',
    assigneeName: 'Ansvarig',
    photo: 'Bild',
    video: 'Video',
    noMessage: 'Inget meddelande',
    markAsRead: 'Markera som läst',
    markAsUnread: 'Markera som oläst',
    read: 'Läst',
    unread: 'Oläst',
    downloadPdfTitle: 'Ladda ner en PDF-rapport med bilden, kommentarer och detaljer',
    downloading: 'Laddar ner…',
    downloadPdf: 'Ladda ner PDF-rapport',
    downloadImageAs: 'Ladda ner bilden som',
    downloadJpegTitle: 'Ladda ner originalbilden som JPEG-fil',
    downloadPngTitle: 'Ladda ner originalbilden som PNG-fil',
    jpeg: 'JPEG',
    png: 'PNG',
    pdf: 'PDF',
    downloadVideo: 'Ladda ner videon',
    sendImage: 'Skicka bilden med e-post',
    sendVideo: 'Skicka videon med e-post',
    loadingData: 'Laddar ärenden',
    noReports: 'Inga ärenden att visa',
    markCheckedReadTitle: 'Markera alla valda ärenden som lästa',
    markCheckedUnreadTitle: 'Markera alla valda ärenden som olästa',
    markCheckedRead: 'Markera valda som lästa',
    markCheckedUnread: 'Markera valda som olästa',
    uncheckAllTitle: 'Avmarkera alla ärenden i listan',
    checkAllTitle: 'Välj alla ärenden i listan',
    unselectAll: 'Avmarkera alla',
    selectAll: 'Välj alla',
    onlyProjectsWithItems: 'Bara projekt med ärenden visas. <link>Klicka här</link> för att se alla projekt',
    projectLabel: 'Projekt:',
    statusLabel: 'Status:',
    noFiles: 'Inga ärenden.',
    new: 'Ny',
    selectItem: 'Välj ärendet',
    reportFailed: 'Kunde inte skapa PDF-rapporten.',
    open: 'Öppna',
    comment: 'Kommentera',
    download: 'Ladda ner',
    moreActions: 'Fler val'
  },
  deleteModal: {
    title: 'Ta bort ärendet?',
    confirm: 'Ärendet och dess bild eller video tas bort för alla.',
    bothRemoved: 'Det går inte att ångra.',
    confirmButton: 'Ta bort ärendet',
    deleted: 'Ärendet har tagits bort'
  },
  commentModal: {
    title: 'Intern kommentar',
    saved: 'Kommentaren har sparats',
    saveFailed: 'Kunde inte spara kommentaren.'
  }
};
